import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"

interface Props {
  children: React.ReactNode
}
/**
 * Router遷移時にpage最上部へスクロールするコンポーネント
 * @param {string} child - ページの中身（ReactNode）
 */
const ScrollTop = ({ children }: Props) => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return <>{children}</>
}

export default ScrollTop
